// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fidsy theme for the workflow designer (vue-flow). Mirrors the agent designer
   look. Namespaced under .workflow-designer so it never leaks elsewhere. */

.workflow-designer {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fbfaff;
  background-image: radial-gradient(circle, #e4dff4 1px, transparent 1px);
  background-size: 22px 22px;
}

.workflow-designer .vue-flow__pane {
  cursor: grab;
}
.workflow-designer .vue-flow__pane.dragging {
  cursor: grabbing;
}

/* coloured "ports" */
.workflow-designer .vue-flow__handle {
  width: 7px;
  height: 18px;
  min-width: 0;
  min-height: 0;
  border: none;
  border-radius: 4px;
  pointer-events: none;
}
.workflow-designer .vue-flow__handle-left {
  background: #41a0ff;
}
.workflow-designer .vue-flow__handle-right {
  background: #5b47c2;
}

/* edges — Fidsy purple, dashed, animated */
.workflow-designer .vue-flow__edge.wf-edge .vue-flow__edge-path {
  stroke: #5b47c2;
  stroke-width: 2;
  stroke-linecap: round;
}
.workflow-designer .vue-flow__edge.wf-edge.animated .vue-flow__edge-path {
  stroke-dasharray: 6;
  animation: wf-dashdraw 0.7s linear infinite;
}
.workflow-designer .vue-flow__edge.wf-edge--end .vue-flow__edge-path {
  stroke: #9b97b5;
}
@keyframes wf-dashdraw {
  from {
    stroke-dashoffset: 12;
  }
  to {
    stroke-dashoffset: 0;
  }
}

/* ---- generic node card ---- */
.workflow-designer .wf-node {
  position: relative;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e7e3f5;
  border-radius: 12px;
  box-shadow: 0px 0px 4px rgba(71, 41, 111, 0.16);
  font-family: 'Inter', sans-serif;
}

/* ---- step node ---- */
.workflow-designer .wf-step {
  width: 280px;
  cursor: pointer;
}
.workflow-designer .wf-step__header {
  padding: 9px 14px;
  font-size: 13px;
  font-weight: 700;
  color: #1c1955;
  border-bottom: 1px solid #ece9f6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.workflow-designer .wf-step__body {
  padding: 6px 12px 10px;
}
.workflow-designer .wf-step__body:empty::after {
  content: 'Empty step';
  display: block;
  padding: 6px 2px;
  font-size: 12px;
  color: #b2b1b9;
}

/* ---- start node ---- */
.workflow-designer .wf-start {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 150px;
  padding: 12px 14px;
  border: 1.5px solid #c9bff1;
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f7f4ff 100%);
  box-shadow: 0px 2px 4px rgba(35, 17, 131, 0.16);
  cursor: pointer;
}
.workflow-designer .wf-start__icon {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #5b47c2;
  color: #ffffff;
}
.workflow-designer .wf-start__label {
  font-size: 14px;
  font-weight: 700;
  color: #1c1955;
}

/* ---- external endpoint node ---- */
.workflow-designer .wf-external {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 220px;
  padding: 9px 12px;
  border-style: dashed;
  border-color: #d6d0ee;
  background: #faf9ff;
  box-shadow: none;
}
.workflow-designer .wf-external__icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f1eefb;
  color: #6d6298;
}
.workflow-designer .wf-external__label {
  font-size: 12px;
  font-weight: 600;
  color: #6d6298;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.workflow-designer .wf-external--end .wf-external__icon {
  background: #f1f0f4;
  color: #8b8b97;
}

/* ---- add-step button (canvas overlay) ---- */
.workflow-designer .wf-add-step {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 5;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
